/**
 * Family AI bot icon: just the Amharic letter "አ" (U+12A0), the first
 * letter of the Ge'ez/Amharic alphabet.
 *
 * The glyph uses a bundled single-character subset of Noto Sans Ethiopic
 * (loaded via @font-face in index.css) so it renders identically on every
 * device — no dependency on the OS having an Ethiopic font installed.
 */
export function AiBotIcon({
  size = 28,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      style={{ display: "block" }}
    >
      <text
        x="16"
        y="26"
        textAnchor="middle"
        fill={color}
        style={{
          fontFamily:
            '"Noto Ethiopic A", "Noto Sans Ethiopic", "Nyala", "Kefa", "Abyssinica SIL", system-ui, serif',
          fontSize: "30px",
          fontWeight: 600,
        }}
      >
        አ
      </text>
    </svg>
  );
}
